import React, { useEffect } from 'react';

function LeSceau() {
    useEffect(() => {
        // Change the title of the page
        document.title = 'le-sceau';
    }, []);

    return (
        <div className='le-sceau'>
            <h1>Le sceau</h1>
            <div className="text-center">
                <img src="/img/le-sceau.png" alt="Le sceau" style={{ maxWidth: "90vw", maxHeight: "50vh", height: "auto" }} />
                <p>Ce symbole est bien la solution , bravo !</p>
                <p>Les éléments que tu trouves en plus sur la double-page 18-19 serviront pour d'autres énigmes.</p>
            </div>
        </div>
    );
}

export default LeSceau;
